var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('Header'),_c('div',{staticClass:"MaxWid"},[_vm._v("\n        123\n    ")]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }